"use client";
import React, { useEffect, useState } from "react";
import { OnloadScheduledOrderModal } from "./onloadScheduleOrderModal";
import { isBusinessOpen } from "../notAcceptingOrdersBanner/notAcceptingOrdersBanner";

export const OnloadScheduleOrderPopup = ({ merchant, merchantColor }: any) => {
  const isPopupTouched = global?.window?.sessionStorage.getItem(
    "onload_scheduledOrderPopup_isTouched"
  );
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isTouched, setIsTouched] = useState(!!isPopupTouched);
  const [isPreview, setIsPreview] = useState(false);

  useEffect(() => {
    setIsPreview(window.location.hostname.startsWith("preview-"));
  }, []);

  const closeModal = () => {
    const existingFlag = Boolean(isPopupTouched);
    global?.window?.sessionStorage.setItem(
      "onload_scheduledOrderPopup_isTouched",
      JSON.stringify(!existingFlag)
    );
    setIsTouched(!existingFlag);
    setIsModalOpen(false);
  };

  if (isTouched || isPreview || !isBusinessOpen(merchant)) return null;

  return (
    <OnloadScheduledOrderModal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      merchant={merchant}
      merchantColor={merchantColor}
    />
  );
};
